import React from 'react';

type WizardStepType = {
  children: React.ReactNode;
  tabId: string;
};
const WizardStep = ({ children, tabId }: WizardStepType) => (tabId ? children : 'TabId not provided');

export default WizardStep;
